export default {"src":"/_next/static/media/multi-platform-acquisition.3e8f4053.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};